const authSessionChannel = new BroadcastChannel('auth-session');

let tabId: string | null = null;
export function myTabId() {
  if (tabId) return tabId;
  let id = sessionStorage.getItem('tabId');
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem('tabId', id);
  }
  tabId = id;
  return id;
}

export type AuthBusMessage = { type: 'NEW_LOGIN'; tabId: string; sub: string; at: number } | { type: 'LOGOUT'; tabId: string; at: number };

export function announceNewLogin(sub: string) {
  authSessionChannel.postMessage({ type: 'NEW_LOGIN', tabId: myTabId(), sub, at: Date.now() } as AuthBusMessage);
}

export function announceLogout() {
  authSessionChannel.postMessage({ type: 'LOGOUT', tabId: myTabId(), at: Date.now() } as AuthBusMessage);
}

export function onAuthBusMessage(cb: (msg: AuthBusMessage) => void) {
  const handler = (event: MessageEvent) => {
    const { data } = event;
    if (!data?.type || !data?.tabId) return;
    cb(data as AuthBusMessage);
  };
  authSessionChannel.addEventListener('message', handler);
  return () => authSessionChannel.removeEventListener('message', handler);
}
